import gql from 'graphql-tag'

export default gql`
query queryAvailableTimes(
  $serviceId: ID!
  $dateFrom: DateTime!
  $dateTo: DateTime!
  $duration: Int!
  $staffsIds: [ID!]
  $ignoreAppointmentId: ID
  $includeDisabledStaffId: ID
) {
  availableTimes(
    dateFrom: $dateFrom
    dateTo: $dateTo
    serviceId: $serviceId
    duration: $duration
    filterStaffsIds: $staffsIds
    ignoreAppointmentId: $ignoreAppointmentId
    includeDisabledStaffId: $includeDisabledStaffId
  ) {
    times
  }
}
`
